// Копировать текст
export const copyText = (text) => {
    navigator.clipboard.writeText(text);
}

export const copyUrl = () => {
    navigator.clipboard.writeText(window.location.href);
}